import type { HttpWhatsAppSender } from '@/modules/settings/adapters/channels/HttpWhatsAppSender';
import { WhatsAppSender } from '@/modules/settings/domain/channels/WhatsAppSender';
import {
  canRestartRegistration,
  resolveSenderState,
} from '@/modules/settings/domain/channels/WhatsAppSenderState';

export class HttpWhatsAppSenderFactory {
  static make(sender: HttpWhatsAppSender): WhatsAppSender {
    return new WhatsAppSender(
      sender.id,
      sender.phoneNumber,
      resolveSenderState(sender.status, sender.senderSid),
      canRestartRegistration(sender.status, sender.senderSid),
    );
  }
}
